import React, { useEffect, useReducer, useState } from "react";
import "./DashboardSelectRegisterPage.css";
import {
  Avatar,
  Button,
  Center,
  Checkbox,
  Divider,
  Group,
  Image,
  Table,
  Text,
  Title,
  UnstyledButton,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import AppModelConfrimSave from "../../(dialogs)/AppModelConfrimSave";
import { IconAlertCircle, IconX } from "@tabler/icons-react";
import DetailUser from "../component/DetailUser";
import AppModelConfrimRemove from "../../(dialogs)/AppModelConfrimRemove";
import AppModelUseSet from "../../(dialogs)/AppModelUseSet";
import AppModelAddress from "../../(dialogs)/AppModelAddress";
import { isNotEmpty, useForm } from "@mantine/form";
import { url } from "../../settings/linkUrl";
import { notifications } from "@mantine/notifications";

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
}

interface RowMoney {
  register: string;
  photo: string;
  set: string;
  rentset: string;
  register_and_photo: string;
  frm_register: string;
  frm_photo: string;
  frm_set: string;
  frm_rentset: string;
  frm_register_and_photo: string;
}

export default function DashboardSelectRegisterPage() {
  const nav = useNavigate();
  const [dataUser, SetdataUser] = useState<RowDataUser>();
  const [dataMoney, SetdataMoney] = useState<RowMoney>();

  const [valuePhoto, setValuePhoto] = useState<string[]>(["0"]);
  const [valueSet, setValueSet] = useState<string[]>(["0"]);
  const [valueRentset, setValueRentset] = useState<string[]>(["0"]);

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));

    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/showdetail`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        SetdataMoney(json);
        form.setFieldValue("register", json.frm_register);
        form.setFieldValue("photo", json.frm_photo);
        form.setFieldValue("set", json.frm_set);

        if (json.frm_photo === "1") {
          setValuePhoto(["1"]);
        }

        if (json.frm_set === "1") {
          setValueSet(["1"]);
        }
        if (json.frm_rentset === "1") {
          setValueRentset(["1"]);
        }
        form.setFieldValue("rentset", json.frm_rentset);
        form.setFieldValue("register_and_photo", json.frm_register_and_photo);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const form = useForm({
    initialValues: {
      register: "1", // 0 = ไม่ลงทะเบียน, 1 = ลงทะเบียน //ลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร
      photo: "0",
      set: "0",
      rentset: "0",
      register_and_photo: "0", // 0 = ไม่ลงทะเบียน, 1 = ลงทะเบียน //ลงทะเบียนซ้อมรับพระราชทานปริญญาบัตรพร้อมรูปถ่าย
      register_food: "0",
    },
  });

  useEffect(() => {
    LoadPage();
  }, []);

  const confrimRegister = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form.values),
    };
    fetch(`${url}register/index`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          nav(`/dashboard/confrim-register`);
        } else if (json.data.success === "0") {
          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
            icon: <IconAlertCircle />,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const cancelRegister = () => {
    nav(`/dashboard`);
  };

  const setPhoto = (e: string[]) => {
    setValuePhoto(e);
    if (e.length === 1) {
      form.setFieldValue("photo", e[0]);
    } else if (e.length === 2) {
      form.setFieldValue("photo", e[1]);
    }
  };
  const setSet = (e: string[]) => {
    setValueSet(e);
    setValueRentset(["0"]);

    if (e.length === 1) {
      form.setFieldValue("set", e[0]);
    } else if (e.length === 2) {
      form.setFieldValue("set", e[1]);
      form.setFieldValue("rentset", e[0]);
    } else {
      form.setFieldValue("set", "0");
    }
  };
  const setRentset = (e: string[]) => {
    setValueRentset(e);
    setValueSet(["0"]);
    if (e.length === 1) {
      form.setFieldValue("rentset", e[0]);
    } else if (e.length === 2) {
      form.setFieldValue("rentset", e[1]);
      form.setFieldValue("set", e[0]);
    } else {
      form.setFieldValue("rentset", "0");
    }
  };

  return (
    <div className="DashboardSelectRegisterPage">
      <section>
        <DetailUser />
      </section>
      <Divider my="xs" size="sm" color="red" />
      <Center>
        <Text c="red" size="lg">
          ประสงค์เข้าร่วม คลิกเลือกรายการที่ท่านประสงค์
        </Text>
      </Center>

      <Divider my="xs" size="sm" color="red" />
      <section>
        <Table w="100%" layout="fixed" withRowBorders={false}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th w="62%">Description</Table.Th>
              <Table.Th w="22%" ta="center">Amount (Bath)</Table.Th>
              <Table.Th w="16%" ta="center">Click</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>
                <Text c="blue" size="lg">
                  ค่าดำเนินการในวันซ้อมรับพระราชทานปริญญาบัตรและวันรับปริญญาบัตร
                </Text>
                <ul>
                  <li>
                    อาหารกลางวัน/น้ำดื่ม ระหว่างฝึกซ้อม 2 มื้อ
                    อาหารว่างที่มหาวิทยาลัยราชภัฏพิบูลสงคราม จังหวัดพิษณุโลก 1 มื้อ
                  </li>
                  <li>อาหารว่าง น้ำดื่ม ระหว่างฝึกซ้อม 4 มื้อ</li>
                  <li>ของที่ระลีก</li>
                </ul>
              </Table.Td>
              <Table.Td ta="center">
                {dataMoney?.register}
              </Table.Td>
              <Table.Td ta="center">
                <Checkbox
                  disabled
                  checked={form.values.register === "1"}
                  color="cyan"
                  readOnly
                />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                <Text c="blue" size="lg">
                  ค่าถ่ายรูปหมู่บัณฑิต พร้อมกรอบหลุยส์ 2 ภาพ
                </Text>
                <ul>
                  <li>ภาพขนาด 12 x 24-28 นิ้ว จำนวน 1 ภาพ</li>
                  <li>ภาพขนาด 12 x 18 นิ้ว  จำนวน 1 ภาพ</li>
                </ul>
              </Table.Td>
              <Table.Td ta="center">{dataMoney?.photo}</Table.Td>
              <Table.Td ta="center">
                <Checkbox.Group value={valuePhoto} onChange={setPhoto}>
                  <Checkbox value="1" color="cyan" />
                </Checkbox.Group>
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                <Text c="blue" size="lg">
                  ค่าตัดชุดครุยวิทยฐานะและเข็มวิทยฐานะ
                </Text>
                <ul>
                  <li>ชุดครุยวิทยาฐานะของมหาวิทยาลัยราชภัฏกำแพงเพชร</li>
                  <li>เข็มตรามหาวิทยาลัยราชภัฏกำแพงเพชร</li>
                </ul>
                <Text size="sm" c="red">*หมายเหตุ หากสั่งจองนอกระบบกับสำนักบริการวิชาการและจัดหารายได้ไว้แล้ว ไม่ต้องเลือกรายการนี้ หากเลือกจะไม่มีการคืนเงิน</Text>
              </Table.Td>
              <Table.Td ta="center">{dataMoney?.set}</Table.Td>
              <Table.Td ta="center">
                <Checkbox.Group value={valueSet} onChange={setSet}>
                  <Checkbox value="1" color="cyan" />
                </Checkbox.Group>
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </section>
      <Group justify="center" mt="md">
        <AppModelConfrimSave onLoadPage={confrimRegister} nameBtn="ลงทะเบียน" />
        <AppModelConfrimRemove onLoadPage={cancelRegister} nameBtn="ยกเลิก" />
      </Group>
    </div>
  );
}
